export default "__VITE_ASSET__badc194b__"